import React from "react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import Services from "@/components/sections/Services";
import CTASection from "@/components/CTASection";

export default function ServicesPage() {
    return (
        <PageShell>
            <div data-testid="services-page">
                <PageHeader
                    eyebrow="Services"
                    title="Seven disciplines."
                    accent="One outcome."
                    subtitle="Every service we offer is engineered to introduce, educate, and retain Vantage clients with integrity — not gimmicks."
                    breadcrumbs={[{ label: "Services" }]}
                />
                <Services />
                <CTASection
                    eyebrow="Engage Us"
                    title="Which service is right for"
                    accent="your goal?"
                    subtitle="Tell us a little about your trading background or your IB ambitions, and we'll route you to the right specialist on the team."
                />
            </div>
        </PageShell>
    );
}
